var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cloneDeep from 'lodash/cloneDeep';
import constants from './constants';

var HEATMAP_LEGEND_BASE = {
	align: 'right',
	layout: 'vertical',
	margin: 0,
	verticalAlign: 'top',
	y: 22,
	symbolHeight: 150
};

var configureLegend = function configureLegend(widgetConfig, seriesDataObj, customConfig) {
	var ChartConfig = widgetConfig.ChartConfig,
	    GaugeConfig = widgetConfig.GaugeConfig,
	    HeatmapConfig = widgetConfig.HeatmapConfig,
	    TreemapConfig = widgetConfig.TreemapConfig;


	if (!ChartConfig) {
		var isGauge = GaugeConfig && (GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE || GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.GAUGESERIES);

		if (isGauge) return {};else if (HeatmapConfig) return HEATMAP_LEGEND_BASE;else if (TreemapConfig && seriesDataObj) return { enabled: TreemapConfig.ShowLegend };else return { enabled: false };
	}

	var ShowLegend = ChartConfig.ShowLegend,
	    LegendLocation = ChartConfig.LegendLocation,
	    ChartType = ChartConfig.ChartType;

	var defaultVerticalAlign = ChartType === 'ScatterPlot' || ChartType === 'Bubble' ? 'top' : 'middle';

	var config = {
		enabled: ShowLegend,
		alignColumns: true,
		align: LegendLocation === 'Left' ? 'left' : LegendLocation === 'Right' ? 'right' : 'center',
		verticalAlign: LegendLocation === 'Top' ? 'top' : LegendLocation === 'Bottom' ? 'bottom' : defaultVerticalAlign,
		maxHeight: LegendLocation === 'Left' || LegendLocation === 'Right' ? undefined : 35,
		layout: LegendLocation === 'Left' || LegendLocation === 'Right' ? 'vertical' : 'horizontal',
		width: LegendLocation === 'Left' || LegendLocation === 'Right' ? 100 : undefined,
		margin: 6,
		padding: 4
	};

	return _extends({}, config, cloneDeep(customConfig));
};

export default configureLegend;